export default __webpack_public_path__ + "static/media/brief-case-with-medical-shield.275a225a.svg";